import { ViewEncapsulation, Component, OnInit, ElementRef, ViewChild, Output, EventEmitter, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';
// tslint:disable-next-line: no-var-requires
const opentip: any = require('@toro/common/shared/scripts/tooltip.js');

@Component({
    selector: 'stock-cards',
    templateUrl: './stock-cards.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class StockCardsComponent implements OnInit, AfterViewInit {

    public followStock: number = 0;
    public loading: boolean = true;

    public cardSize: any = {
        width: 0,
        height: 0,
    };

    @ViewChild('elementCard', {static: true}) public elementCard: ElementRef;
    @ViewChild('loading', {static: false}) public loadingElement: boolean;
    @ViewChild('modalDayTrade', {static: false}) public modalDayTrade: ModalComponent;

    @Output() public emmiter: EventEmitter<string> = new EventEmitter<string>();

    @Output() public onHide: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output() public onLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() public stockDetails: any;

    constructor(
        protected router: Router,
        protected dialogsService: DialogsService,
        protected store: Store<AppState>,
        protected changeDetectorRef: ChangeDetectorRef,
    ) {

        setTimeout(() => {
            this.loading = false;
        }, 1000);

    }

    public ngOnInit() {
        this.startTips();
    }

    public ngAfterViewInit() {
        this.onHide.subscribe((event) => {
            this.changeDetectorRef.detach();
        });
    }

    public ngAfterContentInit() { /* */ }

    public changeFollow($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.followStock = (this.followStock === 1) ? 2 : 1;
    }

    /**
     * Atualiza a altura do card
     * @param height altura (em px)
     */
    public updateHeight(height: number) {
        if (this.elementCard) {
            this.elementCard.nativeElement.setAttribute('style', `height: ${height}px`);
        }
    }

    /**
     * Verifica horário se ainda está dentro do "pregão"
     */
    public isTradingHour() {
        const date = new Date();
        if ((date.getHours() >= 9 && date.getHours() <= 16) || (date.getHours() === 16 && date.getMinutes() <= 30)) {
            return true; // ainda ta dentro do horário do pregão, e pode executar ação de cancelar dayTrade
        } else {
            return false; // saiu do pregão, não pode cancelar dayTrade mais
        }
    }

    /**
     * Abre modal de confirmação
     */
    public openModalConfirm(titulo: string, mensagem: string, confirm: string, cancel: string): Observable<boolean> {
        return this.dialogsService.confirmAction(titulo, mensagem, confirm, cancel);
    }

    /**
     * Modal que abre ao clicar nos botões de Criar Planejamento
     * Botão também aparece no cabeçalho da página de Acompanhamento
     */
    public openModalCreatePlan() {
        const msg = `Quando você cria um plano de lucro e prejuízo, o valor que você precisa para investir pode ser reduzido.
        A diferença será transferida para sua conta corrente da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }.`;
        this.openModalConfirm('Você quer criar um planejamento para este investimento?', msg, 'Criar', 'Voltar')
            .subscribe((result) => {
                if (result) {
                    this.router.navigate(['/meus-investimentos/com-investimento']);
                }
            });
    }

    /**
     * Tooltips
     */
    public startTips() {

        opentip.styles.tag = {
            ajax: true,
            extends: 'glass',
            className: 'tooltip',
            fixed: true,
            tipJoint: 'top',
            shadowBlur: 20,
            stemLength: 15,
            shadowOffset: [1, 1],
            stemBase: 15,
            background: '#FFF',
            borderColor: 'transparent',
            borderRadius: 0,
        };

        setTimeout(() => {
            $('.popover-link-encerra-hoje--js')
            .map((i, el) => {
            // tslint:disable: no-unused-expression
                new opentip(
                    el,
                    `<div>              
                    <div class='pop-title'>Encerra hoje, automaticamente.</div>
                        <div class='pop-content'>
                            O investimento encerra, automaticamente, no fim do dia.
                        </div>
                    </div>`,
                    '',
                    { style: 'tag' },
                );
            });

            $('.popover-link-lucro-prejuizo--js')
            .map((i, el) => {
                new opentip(
                    el,
                    `<div>              
                    <div class='pop-title'>Lucro e prejuízo</div>
                        <div class='pop-content'>
                            Quando você <strong>cria um plano</strong> de lucro e prejuízo,
                            seu investimento encerra automaticamente assim que atinge os valores que você <strong>planejou</strong>.
                        </div>
                    </div>`,
                    '',
                    { style: 'tag' },
                );
            });

            $('.popover-link-lucro--js')
            .map((i, el) => {
                new opentip(
                    el,
                    `<div>              
                    <div class='pop-title'>Lucro</div>
                        <div class='pop-content'>
                            O investimento encerra quando alcançar o lucro planejado.
                            O valor do lucro pode variar de acordo com as condições do mercado.
                        </div>
                    </div>`,
                    '',
                    { style: 'tag' },
                );
            });

            $('.popover-link-prejuizo--js')
            .map((i, el) => {
                new opentip(
                    el,
                    `<div>              
                    <div class='pop-title'>Prejuízo</div>
                        <div class='pop-content'>
                            O investimento encerra quando alcançar o prejuízo planejado.
                            O valor do prejuízo pode variar de acordo com as condições do mercado.
                        </div>
                    </div>`,
                    '',
                    { style: 'tag' },
                );
            });
        }, 100);

    }
}
